// user-specific permissions

import {
  ADMIN_ROLE,
  READ_ONLY_ROLE,
  MANAGER_ROLE
} from 'constants/authConstants';

// n.b.: these roles are likely to change at some point;
// do not reference the is<Role> functions directly
export const isAdmin = ({ role }) => role === ADMIN_ROLE;
export const isReadOnly = ({ role }) => role === READ_ONLY_ROLE;
export const isManager = ({ role }) => role === MANAGER_ROLE;
// use these: function-based permissions
export const canPostJobRequest = user => user.canPostJobs;
export const canCancelJob = user => isReadOnly(user) === false;
export const canBlockWorker = user => isReadOnly(user) === false;
export const canFavoriteWorker = user => isReadOnly(user) === false;
export const canAssignJROwner = user => isAdmin(user) === true;
export const canAdjustJob = user => isReadOnly(user) === false;

export const canCreateVenue = user => isAdmin(user);
export const canDeleteVenue = user => isAdmin(user);
export const canMergeVenue = user => isAdmin(user);
export const canEditVenue = user => isAdmin(user) || isManager(user);

export const canCreateShift = user => isAdmin(user);
export const canDeleteShift = user => isAdmin(user);
export const canEditShift = user => isAdmin(user) || isManager(user);

export const canSeeRecentJobsMessage = user => isAdmin(user) === false;

export const canAccessInvoiceReport = user => isAdmin(user);

export const canEditCompany = user => isAdmin(user);
export const canEditRequestors = user => isAdmin(user);
export const canAccessFullWorkersData = user => isAdmin(user);

export const canAccessLookerReport = user => isAdmin(user);
